<app-dialog
  [title]="data.title"
  [actions]="[
    { text: 'Cancel'},
     { text: 'Save',isDisabled:link.invalid || amount.invalid}]"
  (action)="action($event)"
  (close)="close()"
>
<div class="input-container my-3" *ngIf="!data.isLink">
    <div class="input-container_label">
      Refund Amount
    </div>
    <div class="input-container_wrapper">
      <input type="number" class="input-container_input input-container_input--number" [formControl]="amount" [min]="1"/>
      <span class="input-container_icon">
        <i class="fa fa-dollar-sign"></i>
      </span>
    </div>
  </div>
  <div class="input-container my-3" *ngIf="data.isLink">
    <label class="input-container_label">Case Link</label>
    <input
      type="text"
      class="input-container_input"
      [formControl]="link"
    />
  </div>
</app-dialog>